// extracted by mini-css-extract-plugin
export default {"homepage":"styles_homepage__GoLhR","loader":"styles_loader__Yjgj9"};